<template>
  <v-chip small>{{ formattedEvent }}</v-chip>
</template>

<script>
import { getMigrationEventCode } from "@/helpers/variables/migrations";

export default {
  name: "Event",

  props: {
    code: { type: String, default: "" },
  },
  computed: {
    config() {
      return getMigrationEventCode()[this.code] || {};
    },
    formattedEvent() {
      return this.config.formattedEvent;
    },
  },
};
</script>
